const GAME_NAME = 'hangedman_game';

const GAGameStart = () => {
  if (window.ga) {
    const isStarted = localStorage.getItem(`${GAME_NAME}_isStarted`);
    if (!isStarted) {
        window.ga('send', 'event', GAME_NAME, 'game_start_uniq');
        localStorage.setItem(`${GAME_NAME}_isStarted`, `true`);
    }
    window.ga('send', 'event', GAME_NAME, 'game_start');
  } else {
    console.error('No GA in WINDOW')
  }
};

const GAGameEnd = (level) => {
    if (window.ga) {
        window.ga('send', 'event', GAME_NAME, 'end', `${level}`);
    } else {
        console.error('No GA in WINDOW')
    }
};

const GAGameWin = () => {
    if (window.ga) {
        window.ga('send', 'event', GAME_NAME, 'game_win');
    } else {
        console.error('No GA in WINDOW')
    }
};

const GAGameRestart = (level) => {
    if (window.ga) {
        window.ga('send', 'event', GAME_NAME, 'game_restarted', `${level}`);
    } else {
        console.error('No GA in WINDOW')
    }
};

export {
  GAGameStart,
  GAGameEnd,
  GAGameWin,
  GAGameRestart,
}